export default "__VITE_ASSET__DsxRp9qw__"